import * as React from "react";
import { RadioElement, RadioProps } from "./RadioElement";
import { RadioGroupContext } from "./RadioGroup";

export const Radio: React.FC<RadioProps> = props => (
    <RadioGroupContext.Consumer>
        {({ name, selectedValue, onSelect, disabled }) => (
            <RadioElement
                {...props}
                name={name}
                selectedValue={selectedValue}
                onSelect={onSelect}
                disabled={props.disabled || disabled}
            />
        )}
    </RadioGroupContext.Consumer>
);
